/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElIcon as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_1 from '~icons/custom/copy';
import { ElDivider as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/divider/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0be96eea"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sdk"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "游戏参数", -1));
const _hoisted_3 = {
  class: "margin word-14"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "key"
}, "ProductId：", -1));
const _hoisted_5 = {
  class: "margin word-14"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "key"
}, "ProductKey：", -1));
const _hoisted_7 = {
  class: "margin word-14"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "key"
}, "CallbackKey：", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title",
  style: {
    "margin-top": "36px"
  }
}, "接入方式", -1));
const _hoisted_10 = {
  class: "card-container"
};
const _hoisted_11 = {
  class: "card"
};
const _hoisted_12 = {
  class: "card-item"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "marginT10"
};
import { apiUsdkBatchGetGameInfo } from '@/api/usdk';
import { useAppStore } from '@/store/modules/app';
import { copyText } from '@ultra/share/utils';
import android from '@/assets/images/gameIndex/android.png';
import ios from '@/assets/images/gameIndex/ios.png';
import ue4 from '@/assets/images/gameIndex/ue4.png';
import unity from '@/assets/images/gameIndex/unity.png';
import h5 from '@/assets/images/gameIndex/html5.png';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const list = ref([{
      label: 'Android',
      url: 'http://docs.sdksrv.com/ultra-doc/usdk/android/',
      icon: android
    }, {
      label: 'IOS',
      url: 'http://docs.sdksrv.com/ultra-doc/usdk/iOS/',
      icon: ios
    }, {
      label: 'UE4',
      url: 'http://docs.sdksrv.com/ultra-doc/usdk/ue4/',
      icon: ue4
    }, {
      label: 'Unity',
      url: 'http://docs.sdksrv.com/ultra-doc/usdk/unity/',
      icon: unity
    }, {
      label: 'H5',
      url: 'http://docs.sdksrv.com/ultra-doc/usdk/H5/',
      icon: h5
    }]);
    const useApp = useAppStore();
    const gameInfo = computed(() => useApp.gameInfo);
    const gamePrams = ref({
      productID: '',
      productKey: '',
      callbackKey: ''
    });
    const goFileUrl = url => {
      window.open(url, '_blank');
    };
    // 获取游戏信息
    const getGameInfo = async () => {
      const res = await apiUsdkBatchGetGameInfo({
        gids: gameInfo.value.Id
      });
      if (res.code === 0) {
        var _res$data$, _res$data$2, _res$data$3;
        gamePrams.value = {
          productID: (_res$data$ = res.data[0]) === null || _res$data$ === void 0 ? void 0 : _res$data$.productID,
          productKey: (_res$data$2 = res.data[0]) === null || _res$data$2 === void 0 ? void 0 : _res$data$2.productKey,
          callbackKey: (_res$data$3 = res.data[0]) === null || _res$data$3 === void 0 ? void 0 : _res$data$3.callbackKey
        };
      }
    };
    const handleCopyText = text => {
      copyText(text).then(() => {
        ElMessage({
          type: 'success',
          message: '复制成功！'
        });
      }, () => {
        ElMessage({
          type: 'error',
          message: '复制失败！'
        });
      });
    };
    watch(() => gameInfo.value, val => {
      if (val && val.Id) {
        getGameInfo();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_divider = __unplugin_components_0;
      const _component_i_custom_copy = __unplugin_components_1;
      const _component_el_icon = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, [_hoisted_4, _createTextVNode(_toDisplayString(_unref(gamePrams).productID || '-'), 1)]), _createVNode(_component_el_icon, {
        size: 16,
        class: "cp marginL20",
        onClick: _cache[0] || (_cache[0] = $event => handleCopyText(_unref(gamePrams).productID))
      }, {
        default: _withCtx(() => [_createVNode(_component_i_custom_copy)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, [_hoisted_6, _createTextVNode(_toDisplayString(_unref(gamePrams).productKey || '-'), 1)]), _createVNode(_component_el_icon, {
        size: 16,
        class: "cp marginL20",
        onClick: _cache[1] || (_cache[1] = $event => handleCopyText(_unref(gamePrams).productKey))
      }, {
        default: _withCtx(() => [_createVNode(_component_i_custom_copy)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, [_hoisted_8, _createTextVNode(_toDisplayString(_unref(gamePrams).callbackKey || '-'), 1)]), _createVNode(_component_el_icon, {
        size: 16,
        class: "cp marginL20",
        onClick: _cache[2] || (_cache[2] = $event => handleCopyText(_unref(gamePrams).callbackKey))
      }, {
        default: _withCtx(() => [_createVNode(_component_i_custom_copy)]),
        _: 1
      })]), _hoisted_9, _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "flex flex-col marginR30",
          key: index
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
          style: {
            "width": "70px",
            "height": "70px"
          },
          src: item.icon,
          alt: ""
        }, null, 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, _toDisplayString(item.label), 1)]), _createVNode(_component_el_button, {
          type: "primary",
          class: "marginT20",
          onClick: $event => goFileUrl(item.url),
          style: {
            "font-size": "12px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode("开始接入")]),
          _: 2
        }, 1032, ["onClick"])]);
      }), 128))])]);
    };
  }
});